import { ArrowRight, PlayCircle, ShieldCheck, Server, Send, Cpu } from "lucide-react";
import { HeroVisual } from "@/components/sections/HeroVisual";
import { DeadlineStrip } from "@/components/ui/DeadlineStrip";

const TRUST = [
  { icon: Cpu, label: "MT4 and MT5" },
  { icon: Server, label: "VPS friendly" },
  { icon: ShieldCheck, label: "Risk controls built in" },
  { icon: Send, label: "Telegram support" },
];

export const Hero = ({ config, availability, onPrimary, onSecondary }) => (
  <section
    id="hero"
    className="gm-hero-bg relative overflow-hidden pb-16 pt-14 sm:pb-20 sm:pt-20"
  >
    <div className="gm-container relative lg:grid lg:grid-cols-12 lg:items-center lg:gap-10">
      <div className="lg:col-span-6">
        <div className="gm-chip" data-testid="hero-eyebrow">
          <span
            aria-hidden="true"
            className="h-1.5 w-1.5 rounded-full"
            style={{ background: "var(--gm-red)" }}
          />
          Automated MT4 and MT5 trading
        </div>

        <h1 className="mt-5 text-4xl font-extrabold leading-[1.05] text-white sm:text-5xl lg:text-6xl">
          Goldmap EA
          <span className="mt-2 block text-2xl font-bold sm:text-3xl lg:text-4xl">
            Gold trading on a fixed plan
          </span>
        </h1>

        <p
          className="mt-5 max-w-xl text-sm leading-relaxed sm:text-base"
          style={{ color: "var(--gm-muted)" }}
        >
          Goldmap EA runs inside your own MetaTrader terminal and handles entry,
          basket management and exit for XAUUSD by itself. No prediction, no
          guessing - just the same disciplined cycle repeating, so you tak payah
          duduk depan chart all day.
        </p>

        <div className="mt-7 flex flex-col gap-3 sm:flex-row">
          <button
            type="button"
            onClick={onPrimary}
            data-testid="hero-primary-cta"
            className="gm-btn-red inline-flex min-h-[50px] items-center justify-center gap-2 rounded-xl px-6 text-sm font-bold"
          >
            Get Goldmap EA
            <ArrowRight className="h-4 w-4" />
          </button>
          <button
            type="button"
            onClick={onSecondary}
            data-testid="hero-secondary-cta"
            className="gm-btn-ghost inline-flex min-h-[50px] items-center justify-center gap-2 rounded-xl px-6 text-sm font-semibold"
          >
            <PlayCircle className="h-4 w-4" />
            See how it works
          </button>
        </div>

        <ul className="mt-8 flex flex-wrap gap-2" data-testid="hero-trust-strip">
          {TRUST.map((t) => (
            <li key={t.label} className="gm-chip">
              <t.icon className="h-3.5 w-3.5" style={{ color: "var(--gm-info)" }} />
              {t.label}
            </li>
          ))}
        </ul>

        <div className="mt-7 max-w-md">
          <DeadlineStrip availability={availability} testId="hero-deadline-strip" />
        </div>

        <p className="mt-5 text-xs" style={{ color: "var(--gm-muted-2)" }}>
          Build {config?.version || "v4.2.3"} &middot; your funds stay in your own broker account
        </p>
      </div>

      <div className="mt-12 lg:col-span-6 lg:mt-0">
        <HeroVisual />
      </div>
    </div>
  </section>
);
